/* Warm nearby collapsed FAQ artwork without changing its media settings or lazy markup. */
(() => {
  if (window.quiaFaqImageWarmup) return;
  window.quiaFaqImageWarmup = true;
  const warmed = new Set();
  function warm(details) {
    for (const image of details.querySelectorAll('img')) {
      const src = image.currentSrc || image.src;
      if (!src || warmed.has(src)) continue;
      warmed.add(src);
      const preload = new Image();
      preload.decoding = 'async';
      preload.src = src;
    }
  }
  function init(root) {
    const details = [...root.querySelectorAll('.q28-pdp details[data-rice-faq]')].slice(0, 4);
    const connection = navigator.connection;
    const saveData = connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType));
    const observer = !saveData && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) { warm(entry.target); observer.unobserve(entry.target); }
    }, {rootMargin:'200px'}) : null;
    for (const item of details) {
      if (item.dataset.faqImageWarmup) continue;
      item.dataset.faqImageWarmup = 'true';
      observer?.observe(item);
      for (const event of ['pointerenter','focusin','touchstart']) item.addEventListener(event, () => warm(item), {once:true,passive:true});
    }
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
